import { useApplications, toggleFilterValue, type FilterSectionConfig } from '../model';

import FilterOptionRow from './FilterOptionRow';

type Props = {
  section: FilterSectionConfig;
};

const FilterSection = ({ section }: Props) => {
  const { filters, setFilterValue } = useApplications();
  const current: string[] | undefined = filters[section.key];

  const handleToggle = (value: string) => {
    setFilterValue(section.key, toggleFilterValue(current, value, section.options));
  };

  return (
    <div className="not-first:border-t space-y-2 p-2 pb-3">
      <div className="px-2 text-2xs font-extrabold tracking-wide text-muted-foreground uppercase">{section.title}</div>
      <div className="space-y-1">
        {section.options.map((option) => {
          const checked = Boolean(current?.includes(option.value));

          return (
            <FilterOptionRow
              key={option.value}
              option={option}
              checked={checked}
              onToggle={() => handleToggle(option.value)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default FilterSection;
